import { render, staticRenderFns } from "./login6.vue?vue&type=template&id=548b0c37&scoped=true&"
import script from "./login6.vue?vue&type=script&lang=js&"
export * from "./login6.vue?vue&type=script&lang=js&"
import style0 from "./login6.vue?vue&type=style&index=0&id=548b0c37&prod&lang=scss&"
import style1 from "./login6.vue?vue&type=style&index=1&id=548b0c37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548b0c37",
  null
  
)

export default component.exports